import "overlayscrollbars/styles/overlayscrollbars.css"

import "./overlayscrollbars"
